import React from "react";
import { Navigate } from "react-router-dom";
import { useAppContext } from "context/home/app";

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  allowedRoles,
}) => {
  const { getUserInfo } = useAppContext();
  const userInfo = getUserInfo();

  const userRole = userInfo.roleName;
  const isAuthorized = allowedRoles.includes(userRole);

  if (!isAuthorized) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
